import moment from 'moment'

export function setScheduleDateRange(startDateString) {
    let dates = {}
    if(!moment(startDateString).isValid()) { return dates }
    
    if(startDateString) {
        dates['startDate'] = moment(startDateString).format("MM/DD/YYYY")
        dates['endDate'] = moment(startDateString).endOf('week').add(1, 'day').format("MM/DD/YYYY")

    } else {
        dates['startDate'] = moment().startOf('week').add(1, 'day').format("MM/DD/YYYY")
        dates['endDate'] = moment().endOf('week').add(1, 'day').format("MM/DD/YYYY")
    }

    return dates
}